<template>
  <div>
    <!-- =============================================================================== -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="390">
        <v-card>
          <v-card-title class="headline" style="text-align:center;">Selecione o Trimestre</v-card-title>
          <v-col cols="12" md="12">
            <v-select v-model="trimestre" item-value="idTrimestre" item-text="descricao" :items="trimestres" filled
              color="blue-grey lighten-2" label="Trimestre" @change="carregarRelatorio()" return-object
              :disabled="$store.state.isloading"></v-select>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="fecharComponente()">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="loadPauta()" :disabled="$store.state.isloading">Avançar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--================================================================================== -->

  </div>
</template>
<script>
import axios from '../../../../plugins/axios'
import impressao from '../../../../utilitarios/impressao.utilitario'
const help = require('../../../../../Helpers/Helpers')
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  name: 'minipauta',
  props: ['turma', 'isnota'],
  data: () => ({
    dialog: true,
    relatorio: [],
    relatorio2: [],
    html: ``,
    titulo: 'A mini pauta',
    trimestre: null,
    configuracoesReport: [],
    trimestres: [
      { idTrimestre: 1, descricao: '1º Trimestre', relatorio: 'mnp', relatorioispratico: '' },
      { idTrimestre: 2, descricao: '2º Trimestre', relatorio: 'mnp', relatorioispratico: '' },
      { idTrimestre: 3, descricao: '3º Trimestre', relatorio: 'mnp', relatorioispratico: '' },
      { idTrimestre: 4, descricao: 'Todos', relatorio: 'mnpc', relatorioispratico: 'mnpcp' }
    ],
    configuracoesReport: ls.get('configuracoesReport')
  }),
  computed: {
    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },

    instituicaoId() {
      return ls.get('i_id')
    }
  },
  created() {
  },
  methods: {
    async carregarRelatorio() {
      try {
        const relatoriominipauta = ((this.trimestre.idTrimestre == 4 && this.$store.state.objturma.isPratica == 1) ? this.trimestre.relatorioispratico : this.trimestre.relatorio)

        this.relatorio = await axios.get('/obterRelatorioByDescricao/' + relatoriominipauta).then(res => res.data)

      } catch (error) {
        this.fecharComponente()
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar o relatório' })
      }
    },
    descricaoEscola() {
      let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
      return (this.instituicaoId === 1) ? (configuracaoInstituto[0].valor).toUpperCase() : (ls.get('disciplinasDaTurma').idCurso <= 24 ? this.instituicaodescricao.toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
    },
    async loadPauta() {
      let value = {
        idDsciplina: this.turma.iddisciplina,
        pkTurma: ls.get('disciplinasDaTurma').pkTurma,
        anoLectivo: ls.get('disciplinasDaTurma').anoLectivo
      }
      try {
        this.$store.state.isloading = true
        this.miniPauta = await axios
          .post('/miniPauta', value)
          .then(res => res.data)
        this.miniPauta = this.miniPauta[0]
        this.comporHTML()
      } catch (error) {
        this.fecharComponente()
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro' })
      }
    },
    async comporHTML() {
      if (!this.relatorio.length) {
        Swal.fire({ icon: 'info', title: '', text: 'Mini Pauta não configurada!' })
      } else {
        let miniPautaConfiguracoes = ls.get('configuracoesReport').filter(c => c.obs === 'pauta')
        try {
          let options = {
            'format': 'A4',
            'border': {
              'top': '10mm', // default is 0, units: mm, cm, in, px
              'right': '5mm',
              'bottom': '10mm',
              'left': '5mm'
            }
          }
          this.$store.state.isloading = true
          this.html = this.relatorio[0].documento
          let documentoiter = this.relatorio[0].documentoiteracao1
          let documentoiter2 = this.relatorio[0].documentoiteracao2

          this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
          this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
          this.html = this.html.replace(/{{logotipo}}/g, ls.get('logotipo'))
          this.html = this.html.replace(/{{curso}}/g, ls.get('disciplinasDaTurma').curso)
          this.html = this.html.replace(/{{turma}}/g, ls.get('disciplinasDaTurma').turma)
          this.html = this.html.replace(/{{periodo}}/g, ls.get('disciplinasDaTurma').periodo)
          this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
          this.html = this.html.replace(/{{dataactual}}/g, this.correntDate())
          this.html = this.html.replace(/{{assinatura1}}/g, miniPautaConfiguracoes[1].valor)
          this.html = this.html.replace(/{{assinatura2}}/g, miniPautaConfiguracoes[2].valor)
          this.html = this.html.replace(/{{disciplina}}/g, this.turma.descricao)
          this.html = this.html.replace(/{{classe}}/g, this.turma.classe.replace("Classe", ""))
          this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.descricao)


          let dados = ''
          let i = 0
          if (this.trimestre.idTrimestre === 1) {
            this.html = this.html.replace(/{{headerTable}}/g, this.relatorio[0].documentoiteracao3)
            this.miniPauta.forEach(element => {
              let iteracao = documentoiter
              iteracao = iteracao.replace(/{{nome}}/g, element.nome)
              if (this.isnota === 1) {
                iteracao = iteracao.replace(/{{mac}}/g, this.isNull(element.t1_mac))
                iteracao = iteracao.replace(/{{p1}}/g, this.isNull(element.t1_nota1))
                iteracao = iteracao.replace(/{{p2}}/g, this.isNull(element.t1_nota2))
                iteracao = iteracao.replace(/{{md}}/g, this.isNull(element.t1_md))
                iteracao = iteracao.replace(/{{colormd}}/g, element.colormd1)
              } else {
                iteracao = iteracao.replace(/{{mac}}/g, '')
                iteracao = iteracao.replace(/{{p1}}/g, '')
                iteracao = iteracao.replace(/{{p2}}/g, '')
                iteracao = iteracao.replace(/{{md}}/g, '')
              }


              iteracao = iteracao.replace(/{{zebra}}/g, 'notas ' + this.zebraPauta(i))
              dados += iteracao

              i++
            })
          } else
            if (this.trimestre.idTrimestre === 2) {
              this.html = this.html.replace(/{{headerTable}}/g, this.relatorio[0].documentoiteracao3)
              this.miniPauta.forEach(element => {
                let iteracao = documentoiter
                iteracao = iteracao.replace(/{{nome}}/g, element.nome)
                if (this.isnota === 1) {
                  iteracao = iteracao.replace(/{{mac}}/g, this.isNull(element.t2_mac))
                  iteracao = iteracao.replace(/{{p1}}/g, this.isNull(element.t2_nota1))
                  iteracao = iteracao.replace(/{{p2}}/g, this.isNull(element.t2_nota2))
                  iteracao = iteracao.replace(/{{md}}/g, this.isNull(element.t2_md))
                  iteracao = iteracao.replace(/{{colormd}}/g, element.colormd2)
                } else {
                  iteracao = iteracao.replace(/{{mac}}/g, '')
                  iteracao = iteracao.replace(/{{p1}}/g, '')
                  iteracao = iteracao.replace(/{{p2}}/g, '')
                  iteracao = iteracao.replace(/{{md}}/g, '')
                }
                iteracao = iteracao.replace(/{{zebra}}/g, 'notas ' + this.zebraPauta(i))
                dados += iteracao
                i++
              })
            } else
              if (this.trimestre.idTrimestre === 3) {
                this.html = this.html.replace(/{{headerTable}}/g, this.relatorio[0].documentoiteracao4)
                this.miniPauta.forEach(element => {
                  let iteracao = documentoiter2
                  iteracao = iteracao.replace(/{{nome}}/g, element.nome)
                  if (this.isnota === 1) {
                    iteracao = iteracao.replace(/{{mac}}/g, this.isNull(element.t3_mac))
                    iteracao = iteracao.replace(/{{p1}}/g, this.isNull(element.t3_nota1))
                    iteracao = iteracao.replace(/{{p2}}/g, this.isNull(element.t3_nota2))
                    iteracao = iteracao.replace(/{{md}}/g, this.isNull(element.t3_md))
                    iteracao = iteracao.replace(/{{colormd}}/g, element.colormd3)
                  } else {
                    iteracao = iteracao.replace(/{{mac}}/g, '')
                    iteracao = iteracao.replace(/{{p1}}/g, '')
                    iteracao = iteracao.replace(/{{p2}}/g, '')
                    iteracao = iteracao.replace(/{{md}}/g, '')
                  }
                  iteracao = iteracao.replace(/{{zebra}}/g, 'notas ' + this.zebraPauta(i))
                  dados += iteracao

                  i++
                })

              } if (this.trimestre.idTrimestre === 4) {

                this.miniPauta.forEach(element => {
                  let iteracao = documentoiter
                  i++
                  iteracao = iteracao.replace(/{{indice}}/g, i)
                  iteracao = iteracao.replace(/{{nome}}/g, element.nome)
                  if (this.isnota === 1) {
                    iteracao = iteracao.replace(/{{mac1}}/g, this.isNull(element.t1_mac))
                    iteracao = iteracao.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
                    iteracao = iteracao.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2))
                    iteracao = iteracao.replace(/{{t1_md}}/g, this.isNull(element.t1_md))

                    iteracao = iteracao.replace(/{{mac2}}/g, this.isNull(element.t2_mac))
                    iteracao = iteracao.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1))
                    iteracao = iteracao.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
                    iteracao = iteracao.replace(/{{t2_md}}/g, this.isNull(element.t2_md))

                    iteracao = iteracao.replace(/{{mac3}}/g, this.isNull(element.t3_mac))
                    iteracao = iteracao.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
                    iteracao = iteracao.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2))
                    iteracao = iteracao.replace(/{{t3_md}}/g, this.isNull(element.t3_md))

                    iteracao = iteracao.replace(/{{pg}}/g, this.isNull(element.pg))
                    iteracao = iteracao.replace(/{{mfd}}/g, this.isNull(element.mfd))
                    iteracao = iteracao.replace(/{{colormfd}}/g, element.colormfd)

                    iteracao = iteracao.replace(/{{colormd1}}/g, element.colormd1)
                    iteracao = iteracao.replace(/{{colormd2}}/g, element.colormd2)
                    iteracao = iteracao.replace(/{{colormd3}}/g, element.colormd3)
                  } else {
                    iteracao = iteracao.replace(/{{mac1}}/g, '')
                    iteracao = iteracao.replace(/{{t1_nota1}}/g, '')
                    iteracao = iteracao.replace(/{{t1_nota2}}/g, '')
                    iteracao = iteracao.replace(/{{t1_md}}/g, '')

                    iteracao = iteracao.replace(/{{mac2}}/g, '')
                    iteracao = iteracao.replace(/{{t2_nota1}}/g, '')
                    iteracao = iteracao.replace(/{{t2_nota2}}/g, '')
                    iteracao = iteracao.replace(/{{t2_md}}/g, '')

                    iteracao = iteracao.replace(/{{mac3}}/g, '')
                    iteracao = iteracao.replace(/{{t3_nota1}}/g, '')
                    iteracao = iteracao.replace(/{{t3_nota2}}/g, '')
                    iteracao = iteracao.replace(/{{t3_md}}/g, '')

                    iteracao = iteracao.replace(/{{pg}}/g, '')
                    iteracao = iteracao.replace(/{{mfd}}/g, '')
                  }
                  iteracao = iteracao.replace(/{{zebra}}/g, 'notas ' + this.zebraPauta(i))
                  dados += iteracao


                })
                options = {
                  'format': 'A4',
                  'orientation': 'landscape',
                  'border': {
                    'top': '10mm', // default is 0, units: mm, cm, in, px
                    'right': '5mm',
                    'bottom': '10mm',
                    'left': '5mm'
                  }
                }
              }

          this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
          this.html = this.html.replace(/{{dados}}/g, dados)
          impressao.htmlToPDF(this.html, options, ls.get('urlReport'), ls.get('idPessoa'))

        } catch (error) {
          Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor o PDF' })
          this.fecharComponente()
        } finally {
        }
      }
    },
    correntDate() {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return d.getDate().toString() + ' de ' + month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    zebraPauta(i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    isNull(nota) {
      if (nota) { return nota } else return ''
    },
    fecharComponente() {
      this.dialog = false
      this.$store.state.isloading = false
      this.$emit('fecharComponente', false);
    }
  }
}

</script>
